import { useState } from 'react';
import styled from 'styled-components';

import { Text } from '../../../../cdl/Text/Text';
import { Box } from '../../../../common/ui/Box';
import { theme } from '../../../../common/ui/theme';
import { CategoryColumn } from '../hooks/useScheduleProductColumns';
import { ScheduleLayout } from '../scheduleLayout';

import { ScheduleProductCard } from './ScheduleProductCard';

const ProductHeader = styled.div`
    height: ${ScheduleLayout.HEADER_BAR_HEIGHT};
    width: 100%;
    display: flex;
    align-items: center;
    padding-left: ${theme.space[12]};
    padding-right: ${theme.space[12]};
`;

interface ScheduleProductColumnProps {
    column: CategoryColumn;
    isFirstColumn: boolean;
    isLastColumn: boolean;
}

export const ScheduleProductColumn = ({ column, isFirstColumn, isLastColumn }: ScheduleProductColumnProps) => {
    const [isColumnHovered, setIsColumnHovered] = useState(false);
    const spacerWidth = isFirstColumn
        ? ScheduleLayout.PRODUCT_COLUMN_SPACER_START
        : ScheduleLayout.PRODUCT_COLUMN_SPACER;

    return (
        <Box
            display="flex"
            onMouseEnter={() => setIsColumnHovered(true)}
            onMouseLeave={() => setIsColumnHovered(false)}
        >
            <Box width={spacerWidth} flexShrink={0} />

            <Box flex="1" display="flex" flexDirection="column" gap={ScheduleLayout.ROW_GAP}>
                <Box height={ScheduleLayout.HEADER_HEIGHT} display="flex" alignItems="center">
                    <ProductHeader>
                        <Text variant="body" fontWeight={600}>
                            {column.label}
                        </Text>
                    </ProductHeader>
                </Box>

                {column.items.map((item) => (
                    <Box
                        key={item.scheduleItem.stop.id}
                        data-testid="schedule-product-row"
                        height={ScheduleLayout.ROW_HEIGHT}
                        flexShrink={0}
                    >
                        {item.categoryData ? (
                            <ScheduleProductCard
                                categoryData={item.categoryData}
                                reachInformation={item.reachInformation}
                                isColumnHovered={isColumnHovered}
                            />
                        ) : null}
                    </Box>
                ))}
            </Box>

            {isLastColumn ? <Box width={ScheduleLayout.PRODUCT_COLUMN_SPACER_END} flexShrink={0} /> : null}
        </Box>
    );
};
